import { useEffect } from 'react';
import { FiAlertTriangle, FiX } from 'react-icons/fi';
import { usePreferences } from '../../contexts/PreferencesContext';
import { UPGRADE_WHATSAPP_URL } from '../../utils/planoGratuito';
import styles from './FreePlanLimitModal.module.css';

interface FreePlanLimitModalProps {
    limite: number;
    /** Fechar: a tela de lançar continua bloqueada, então quem chama decide para onde ir. */
    onClose: () => void;
}

/**
 * Aviso de limite atingido do plano Gratuito (MAN-364), sobre a tela de lançar
 * receita ou despesa bloqueada: só o aviso e o "Fazer upgrade" (WhatsApp).
 */
export function FreePlanLimitModal({ limite, onClose }: FreePlanLimitModalProps) {
    const { t } = usePreferences();

    useEffect(() => {
        const aoTeclar = (e: KeyboardEvent) => {
            if (e.key === 'Escape') onClose();
        };
        document.addEventListener('keydown', aoTeclar);
        return () => document.removeEventListener('keydown', aoTeclar);
    }, [onClose]);

    return (
        <div className={styles.overlay}>
            <div className={styles.modal} role="dialog" aria-modal="true" aria-labelledby="plano-gratuito-limite-titulo">
                <button type="button" className={styles.fechar} onClick={onClose} aria-label={t('planoGratuito.fechar')}>
                    <FiX size={18} />
                </button>

                <div className={styles.icone}>
                    <FiAlertTriangle size={22} />
                </div>

                <h2 id="plano-gratuito-limite-titulo" className={styles.titulo}>
                    {t('planoGratuito.limiteTitulo')}
                </h2>
                <p className={styles.descricao}>{t('planoGratuito.limiteModal', { limite: String(limite) })}</p>

                <a className={styles.upgrade} href={UPGRADE_WHATSAPP_URL} target="_blank" rel="noopener noreferrer">
                    {t('planoGratuito.fazerUpgrade')}
                </a>
            </div>
        </div>
    );
}
